<template>
  <div id="app">
    <HeaderComponent />
    <router-view></router-view>

    <b-modal
      id="modalError"
      class="text-center"
      v-model="showError"
      :centered="true"
      :header-bg-variant="'danger'"
      :header-text-variant="'light'"
      :ok-only="true"
      title="Error"
      :ok-variant="'secondary'"
    >
      <div v-html="errorText"></div>
    </b-modal>
  </div>
</template>

<script>
import HeaderComponent from './components/header';
import Pace from "pace-js";

export default {
  name: 'App',
  components: {
    HeaderComponent
  },
  data: function () {
    return {
      errorText: null,
      showError: false
    };
  },
  mounted: function () {
    this.$loadingService.subscribe((show) => {
      show ? Pace.start() : Pace.stop();
    });

    this.$errorService.subscribe((error) => {
      this.errorText = error;
      this.showError = true;
    });
  },
  methods: {
    startLoading() {
      this.$loadingService.startLoading();
    }
  }
};
</script>

<style lang="scss">
@import '../assets/carrier_styles/main';
</style>

<style>
.loading {
  margin-left: 20px;
  font-size: 20px;
}

.loading-modal-body {
  text-align: center;
}
</style>
